<template>
    <div id="mainDiv">


        <div :class=" i==0?'':'margintop5' " v-for="(t,i) in tableData" :key="i">
            <div class="baiseback" :id="'forumItem_'+t.id">

                        <el-dropdown class="pull-right" v-if="IisFqz||IisBanzhu">
                            <el-button type="primary">
                                操作<i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item >
                                    <el-button type="text" icon="el-icon-top"
                                               @click="handleTopbest(i, t,'top')">置顶
                                    </el-button>
                                </el-dropdown-item>
                                <el-dropdown-item v-if="t.topStart!='0'">
                                    <el-button type="text" icon="el-icon-close"
                                               @click="handleCancelTopbest(i, t,'top')">取消置顶
                                    </el-button>
                                </el-dropdown-item>
                                <el-dropdown-item>
                                    <el-button type="text" icon="el-icon-magic-stick"
                                               @click="handleTopbest(i, t,'best')">收录
                                    </el-button>
                                </el-dropdown-item>
                                <el-dropdown-item v-if="t.bestStart!='0'">
                                    <el-button type="text" icon="el-icon-close"
                                               @click="handleCancelTopbest(i, t,'best')">取消收录
                                    </el-button>
                                </el-dropdown-item>
                                <el-dropdown-item  >
                                    <el-button type="text" icon="el-icon-edit" class="red"
                                               @click="editDelete(i, t)">编辑
                                    </el-button>
                                </el-dropdown-item>
                                <el-dropdown-item  >
                                    <el-button type="text" icon="el-icon-delete" class="red"
                                               @click="handleDelete(i, t)">删除
                                    </el-button>
                                </el-dropdown-item>


                            </el-dropdown-menu>
                        </el-dropdown>

                        <div>
                            <table>
                                <tr>
                                    <td valign="top" :class="webW?'pcutd1':'phoneutd1'" >
                                        <img @click="goForumItem(t,i,'top')" :src="t.faceimg"  :class="webW?'pcavatar':'phoneavatar'" >

                                    </td>
                                    <td class="hh hander">
                                        <p @click="goForumItem(t,i,'top')" :class="webW?'pcname':'phonename'" >{{t.uname}}</p>
                                        <p @click="goForumItem(t,i,'top')" class=" typedesc">
                                            <el-tag v-if="t.istop=='1'" size="mini">置顶</el-tag>
                                            <el-tag v-if="t.isbest=='1'" type="danger"  size="mini">收录</el-tag>

                                            <span >发表于  {{t.cts}}</span><span v-if="t.editTs!=null&&t.editTs!=''">，最后编辑  {{t.editTs}}</span></p>

                                    </td>
                                </tr>
                            </table>

                            <h3 class="hh hander" :class="webW?'pctitle':'phonetitle'"  @click="goForumItem(t,i,'top')">
                                {{t.ftitle}}</h3>


                            <div class="wbpro-feed-content">
                                <span class="hh forumcont" v-html="t.fcontext.length>160&&t.hidden?t.fcontext.substring(0,160)+'...':t.fcontext"></span><span v-bind:style="{display:t.fcontext.length>160?'inline':'none'}" v-on:click="toggle" v-bind:rel="i" class="expand">{{t.hidden?'展开':'收起'}}</span>


                                <div style="height: 10px;"></div>

                                <div class="upimgsidvone" v-if="t.imgsli!=null&&t.imgsli.length==1">
                                    <el-image :src="imgt" v-for="(imgt,imgindex) in t.imgsli"  :key="imgindex"  fit="contain" :preview-src-list="t.imgsli" ></el-image>
                                </div>

                                <div  class="upimgsidv" :style="'max-width:'+jiugonggeWidth+'px'" v-if="t.imgsli!=null&&t.imgsli.length>=2">
                                    <el-row>
                                        <el-col :span="8" v-for="(imgt,imgindex) in t.imgsli" :key="imgindex">
                                            <div class="itemdiv" :style="'width:'+jiugonggeItemWidth+'px;height:'+jiugonggeItemWidth+'px;'">
                                                <el-image :src="imgt"  class="upimgcls" fit="cover" :preview-src-list="t.imgsli" ></el-image>
                                            </div>
                                        </el-col>
                                    </el-row>
                                </div>


                                <div class="upimgsidvone" v-if="t.videosli!=null&&t.videosli.length==1">
                                    <div  v-for="(vt,vindex) in t.videosli" :key="vindex">
                                        <video  @timeupdate="jiantingVideo" :src="vt.vurl"   :id="'videoitem_'+t.id" :data-index="i" :data-vindex="vindex" controls   :class="webW?'webbigvideo':'phonebigvideo'"></video>

                                    </div>
                                </div>

                                <div  v-if="t.videosli!=null&&t.videosli.length>=2">
                                    <div  v-show="t.nowvideo.isshow=='1'">
                                        <div>
                                            <video @timeupdate="jiantingVideo" :src="t.nowvideo.vurl"  :id="'videoitem_'+t.id"   :data-index="t.nowvideo.index" :data-vindex="t.nowvideo.vindex" controls class="bigvideo"   :class="webW?'webbigvideo':'phonebigvideo'"></video>

                                        </div>
                                        <el-row>
                                            <el-col :span="3"  v-for="(vt,vindex) in t.videosli" :key="vindex">
                                                <div style="padding: 2px;" :style="'height:'+(videoplayitemWidth)+'px;'">
                                                    <img @click="playvideo(t,i,vt,vindex)"  src="../../../assets/img/player0.png" v-if="vt.isplay=='0'" class="videozhechaoceng"   :style="'width:'+videoplayitemWidth+'px;height:'+videoplayitemWidth+'px;'"  >
                                                    <img @click="stopvideo()"  src="../../../assets/img/player1.png" v-if="vt.isplay=='1'" class="videozhechaoceng"   :style="'width:'+videoplayitemWidth+'px;height:'+videoplayitemWidth+'px;'"   >
                                                    <video  :src="vt.vurl"        :style="'width:'+videoplayitemWidth+'px;height:'+videoplayitemWidth+'px;background-color: #000;'"></video>
                                                </div>
                                            </el-col>
                                        </el-row>


                                    </div>
                                    <div   v-show="t.nowvideo.isshow=='0'" class="upimgsidv" :style="'max-width:'+jiugonggeWidth+'px'">
                                        <el-row>
                                            <el-col :span="8" v-for="(vt,vindex) in t.videosli" :key="vindex">
                                                <div class="itemdiv" :style="'width:'+jiugonggeItemWidth+'px;height:'+jiugonggeItemWidth+'px;'">
                                                    <img @click="playvideo2(t,i,vt,vindex)"  src="../../../assets/img/player0.png" v-if="vt.isplay=='0'" class="videozhechaoceng"  :style="'width:'+(jiugonggeItemWidth-1)+'px;height:'+(jiugonggeItemWidth-1)+'px;'"  >
                                                    <img @click="stopvideo()"  src="../../../assets/img/player1.png" v-if="vt.isplay=='1'" class="videozhechaoceng"  :style="'width:'+(jiugonggeItemWidth-1)+'px;height:'+(jiugonggeItemWidth-1)+'px;'"  >
                                                    <video   :src="vt.vurl"   :style="'width:'+jiugonggeItemWidth+'px;height:'+jiugonggeItemWidth+'px;background-color: #000;'"></video>
                                                </div>
                                            </el-col>
                                        </el-row>
                                    </div>
                                </div>

                                <div style="height: 10px;"></div>


                                <p v-if="t.isVote=='1'" class="typedesc">可投票时间：{{t.vstartTs}} 到 {{t.vendTs}}
                                    <el-tag v-if="t.voteState=='0'" size="mini">未开始</el-tag>
                                    <el-tag v-if="t.voteState=='2'" type="danger"  size="mini">进行中</el-tag>
                                    <el-tag v-if="t.voteState=='1'"  size="mini">已结束</el-tag>
                                    <el-tag v-if="t.ivote=='1'" type="info"  size="mini">你已参与投票</el-tag>
                                </p>
                                <div v-if="t.isVote=='1' && t.vtype=='dx' && t.voteItemli.length>0">
                                    <div v-for="(tv,vi) in t.voteItemli" class="margintop20" :key="vi">
                                        <el-row>
                                            <el-col :span="12">
                                                <el-radio   @change="dxVoteHandle(t,i,tv,vi)" :label="tv.id" v-model="t.myvoteDx" :disabled="(t.voteState=='2'?false:true)||(t.ivote=='0'?false:true)" >{{tv.vitem}}</el-radio>
                                            </el-col>
                                            <el-col :span="12">
                                                <div style="text-align: right;">
                                                    <b class="toupiaob" v-if="t.vshowNum=='1'||t.authorUid==lander.uid">{{tv.peopleNum}}人</b>
                                                    <b class="toupiaob">{{tv.vpercentage}}%</b>
                                                </div>
                                            </el-col>
                                        </el-row>
                                        <div class="row margintop20" >
                                            <div class="col-sm-12"><div class="tpjdt"><div class="seltpjdut" :style="'width:'+tv.vpercentage+'%;'"></div></div> </div>

                                        </div>
                                        <div class="row margintop20"   v-if="(t.vshowPeople=='1'||t.authorUid==lander.uid)&&tv.votePeopleli.length>0">
                                            <div class="col-sm-12">
                                                <el-tooltip effect="dark" :content="tp.uname" placement="top-start" v-for="(tp,pi) in tv.votePeopleli" :key="pi">
                                                    <img  @click="goUHome(tp.voteUid)" :src="tp.faceimg"  class="toupiaofaceimg hander">
                                                </el-tooltip>
                                                <span class="typedesc">...等用户投了一票</span><span @click="seeVotePeople(tv)"  class="hander seetiezi">【查看用户】</span>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                <div v-if="t.isVote=='1' && t.vtype=='mx' && t.voteItemli.length>0">
                                    <el-checkbox-group v-model="t.myvoteMx" >
                                        <div v-for="(tv,vi) in t.voteItemli" class="margintop20" :key="vi">
                                            <el-row>
                                                <el-col :span="12">
                                                    <el-checkbox :label="tv.id" :value="tv.id"  :disabled="(t.voteState=='2'?false:true)||(t.ivote=='0'?false:true)">{{tv.vitem}}</el-checkbox>
                                                </el-col>
                                                <el-col :span="12">
                                                    <div style="text-align: right;">
                                                        <b class="toupiaob"  v-if="t.vshowNum=='1'||t.authorUid==lander.uid">{{tv.peopleNum}}人</b>
                                                        <b class="toupiaob" >{{tv.vpercentage}}%</b>
                                                    </div>

                                                </el-col>
                                            </el-row>



                                            <div class="row margintop20" >
                                                <div class="col-sm-12"><div class="tpjdt"><div class="seltpjdut" :style="'width:'+tv.vpercentage+'%;'"></div></div> </div>

                                            </div>
                                            <div class="row margintop20"   v-if="(t.vshowPeople=='1'||t.authorUid==lander.uid)&&tv.votePeopleli.length>0">
                                                <div class="col-sm-12">
                                                    <el-tooltip effect="dark" :content="tp.uname" placement="top-start" v-for="(tp,pi) in tv.votePeopleli" :key="pi">
                                                        <img @click="goUHome(tp.voteUid)"  :src="tp.faceimg"  class="toupiaofaceimg hander">
                                                    </el-tooltip>
                                                    <span class="typedesc">...等用户投了一票</span><span @click="seeVotePeople(tv)"  class="hander seetiezi">【查看用户】</span></div>
                                            </div>


                                        </div>
                                    </el-checkbox-group>

                                    <div class="center margintop20" v-if="t.ivote=='0'&&t.voteItemli.length>0">
                                        <el-button type="primary" @click="mxVoteHandle(t,i)"  :disabled="t.voteState=='2'?false:true">提交投票</el-button>
                                    </div>

                                </div>

                            </div>

                        </div>

                <div class="h20"></div>
                <el-row class="teiziline">
                    <el-col :span="2"><br></el-col>
                    <!-- <el-col :span="5"><p class=" typedesc center  "><i class="el-icon-view"></i>&nbsp;{{t.viewNum}}
                    </p></el-col> -->
                     <el-col :span="6"><p class=" typedesc center hander" @click="hitHandle(t,i)">
                        <i :class="'fa fa-thumbs-up '+(t.ishit=='1'?'seled':'')"></i>&nbsp;{{t.hitNum}}</p>
                    </el-col>
                    <el-col :span="6"><p class=" typedesc center hander" @click="seeCommentHandel(t,i)"><i
                            class="el-icon-chat-square"></i>&nbsp;{{t.commentNum}}
                    </p></el-col>
                   
                    <el-col :span="5"><p class=" typedesc center hander" @click="collectHandle(t,i)"><i
                            :class="'el-icon-star-off '+(t.iscollect=='1'?'seled':'')"></i>&nbsp;{{t.collectNum}}
                    </p></el-col>
                </el-row>

            </div>
            <!--pl-->
            <el-collapse-transition>
            <div class="fpldiv" v-if="t.showComments">
                <div class="woo-box-flex">
                  <div class="woo-avatar-main">
                    <img  @click="goUHome(lander.uid)"  class="fplfaceimg hander" :src="$store.state.faceimg" >
                  </div>
                  <div class="woo-box-item-flex">
                    <quill-editor  v-model="t.commentCont"   :options="pleditorOption"   :disabled="nouse|| !ihasReplay" class="fpledit"/>
                  </div>
                </div>
                <div class="Tool_check">
                    <el-button @click="subComment(t,i)"   type="warning" round size="mini"  :disabled="nouse|| !ihasReplay">评论</el-button>
                </div>
                <div class="clear">
                    <div class="center" v-if="t.commentliLoading">
                        <img src="../../../assets/img/loading.gif">
                        <p class="typedesc">加载中</p>
                    </div>

                    <div class="center" v-if="!t.commentliLoading&&t.commentli.length==0">
                        <img src="../../../assets/img/zwsj.png" class="zwsjx">
                        <p class="typedesc">暂无数据</p>
                    </div>
                    <div class="fbl_item" v-for="(tc,ic) in t.commentli" :key="ic">
                        <img @click="goUHome(tc.commentUid)" class="fplfaceimg hander" :src="tc.faceimg">
                        <div class="fbl_contsall">

                            <p class="hh fbl_first">
                                <span class="fbl_uname hander" @click="goUHome(tc.commentUid)">{{tc.uname}} </span>
                                <el-tag v-if="tc.istop=='1'" type="danger" size="mini">置顶</el-tag>

                                <span @click="deleteComment(t,i,tc,ic)" v-if="lander.uid== tc.commentUid "
                                      class="pull-right fbl_btnleftline hander">&nbsp;<i class="el-icon-delete"/>删除&nbsp;</span>
                                <span @click="editComment(t,i,tc,ic,1)" v-if="lander.uid== tc.commentUid || IisFqz||lander.role=='100'||IisBanzhu"
                                      class="pull-right fbl_btnleftline hander">&nbsp;<i class="el-icon-edit"/>编辑&nbsp;</span>
                                <span @click="hitComment(t,i,tc,ic,1)"
                                      class="pull-right fbl_btnleftline hander">&nbsp;<i class="fa fa-thumbs-up"/>{{tc.hitNum==0?'点赞':tc.hitNum}}&nbsp;</span>
                                <span @click="replayHandle(t,i,tc,ic,1)" class="pull-right fbl_btnleftline hander">&nbsp;<i
                                        class="el-icon-chat-square"/>回复&nbsp;</span>
                                <span class="fbl_time">{{tc.cts}}</span>

                            </p>

                            <div class="hh  zxplcont margintop5" v-html="tc.cont"></div>


                            <img src="../../../assets/img/reflashing.gif" v-if="tc.hfliLoading" class="suxianing">

                            <div v-if=" tc.hfli.length>0" class="wbpro-list">
                                <div class="fbl_item" v-for="(thf,ihf) in tc.hfli" :key="ihf">
                                    <!-- <img  @click="goUHome(thf.commentUid)" class="fplfaceimg hander" :src="thf.faceimg"> -->
                                    <div class="">

                                        <p class="hh fbl_first">
                                            <span class="fbl_uname hander" @click="replayHandle(t,i,tc,ic,2,thf)">{{thf.uname}}</span>
                                            <span class="fbl_hfwz">回复</span>
                                            <span class="fbl_uname hander" @click="replayHandle(t,i,tc,ic,3,thf)">{{thf.hfuname}}</span>
                                            <el-tag v-if="thf.istop=='1'" type="danger" size="mini">置顶</el-tag>

                                            <span @click="deleteCommentReplay(t,i,tc,ic,thf,ihf)"
                                                  v-if="lander.uid== thf.commentUid "
                                                  class="pull-right fbl_btnleftline hander">&nbsp;<i
                                                    class="el-icon-delete"/>删除&nbsp;</span>
                                            <span @click="editComment(t,i,tc,ic,2,thf,ihf)"
                                                  v-if="lander.uid== thf.commentUid || IisFqz||lander.role=='100'||IisBanzhu"
                                                  class="pull-right fbl_btnleftline hander">&nbsp;<i
                                                    class="el-icon-edit"/>编辑&nbsp;</span>
                                            <span @click="hitComment(t,i,tc,ic,2,thf,ihf)"
                                                  class="pull-right fbl_btnleftline hander">&nbsp;<i
                                                    class="fa fa-thumbs-up"/>{{thf.hitNum==0?'点赞':thf.hitNum}}&nbsp;</span>
                                            <span @click="replayHandle(t,i,tc,ic,2,thf)"
                                                  class="pull-right fbl_btnleftline hander">&nbsp;<i
                                                    class="el-icon-chat-square"/>回复&nbsp;</span>
                                            <span class="fbl_time">{{thf.cts}}</span>

                                        </p>
                                        <div class="hh  zxplcont margintop5" v-html="thf.cont"></div>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div>
                        <span @click="closeComments(t,i)" class="pull-right typedesc hander">隐藏</span>
                        <el-divider class="hander" @click="goForumItem(t,i,'comment')">查看全部评论</el-divider>

                    </div>

                </div>
            </div>
            </el-collapse-transition>
            <!--pl-->
        </div>




        <!-- 添加或者编辑弹出框 -->
        <el-dialog title="回复" :visible.sync="replayVisible"  :modal-append-to-body="false" :width="!webW?'90%':'50%'">
            <el-form label-width="0">
                <p>请输入对' {{replayUname}} '的回复：</p>
                <quill-editor v-model="replayCont" :options="pleditorOption" :disabled="nouse|| !ihasReplay"/>

            </el-form>

            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="replayVisible = false">取 消</el-button>
                    <el-button @click="saveReplay" type="primary" :disabled="nouse|| !ihasReplay">回复</el-button>
                </span>
            </template>
        </el-dialog>


        <!--   评论 -->
        <el-dialog title="编辑评论或者回复" :visible.sync="editCommentVisible"  :modal-append-to-body="false" :width="!webW?'90%':'50%'">
            <el-form label-width="0">
                <quill-editor v-model="editCommentData.cont" :options="pleditorOption" :disabled="nouse|| !ihasReplay"/>

            </el-form>

            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="editCommentVisible = false">取 消</el-button>
                    <el-button @click="editsaveComment" type="primary" :disabled="nouse|| !ihasReplay">确定</el-button>
                </span>
            </template>
        </el-dialog>


        <!-- 查看投票用户 -->
        <el-dialog title="查看投票用户" :visible.sync="votePeopleVisible" :modal-append-to-body="false"  :width="!webW?'90%':'50%'">
            <div class="row" v-if="webW">
                <div class="col-sm-2 center" v-for="(t,i) in votePeopleData" :key="i">
                    <img :src="t.faceimg" @click="goUHome(t.voteUid)"  class="touxiangfantt hander" >
                    <p class="oneline hander" @click="goUHome(t.voteUid)">{{t.uname }}</p>
                </div>
            </div>

            <el-row :gutter="20" v-if="!webW">
                <el-col :span="6"  v-for="(t,i) in votePeopleData" :key="i">
                    <div class="center">
                        <img :src="t.faceimg" @click="goUHome(t.voteUid)"   class="touxiangfantt hander" >
                        <p class="oneline hander" @click="goUHome(t.voteUid)" >{{t.uname}}</p>
                    </div>
                </el-col>

            </el-row>


            <div class="baiseback"  v-if="votePeopleDataloading">
                <div class="center">
                    <img src="../../../assets/img/loading.gif">
                    <p class="typedesc">数据加载中....</p>
                </div>
            </div>
            <div class="baiseback" style="height: 100vh;"  v-if="!votePeopleDataloading&&votePeopleData.length==0">
                <div class="center">
                    <img src="../../../assets/img/zwsj.png">
                    <p class="typedesc">暂无数据</p>
                </div>
            </div>


            <div class="center" >
                <el-pagination v-if="webW"
                               @current-change="handleVotePeoplePageChange"
                               :current-page="votePeopleQuery.pageNo"
                               :page-size="votePeopleQuery.pageSize"
                               layout="total, prev, pager, next"
                               :total="votePeoplePageTotal">
                </el-pagination>


            </div>

            <p class="typedesc center" v-if="!webW" @click="getVotePeoplePage">{{votePeopleDataFinish?'没有数据了':'点击查看更多'}}</p>

            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="votePeopleVisible = false">取 消</el-button>
                </span>
            </template>
        </el-dialog>


        <!--置顶,收录 -->
        <el-dialog :title="(topbestData.type=='top'?'设置置顶':'设置收录')+'-'+ topbestData.ftitle " :visible.sync="topbestVisible"  :modal-append-to-body="false"  :width="!webW?'90%':'50%'">

            <el-date-picker
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    v-model="topbestData.start_end"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
            </el-date-picker>

            <template #footer>


                    <span class="dialog-footer">
                        <el-button @click="topbestVisible = false">取 消</el-button>
                        <el-button type="primary" @click="saveTopbestHnadle">确 定</el-button>
                    </span>
            </template>
        </el-dialog>

        <!--删除 -->
        <el-dialog :title=" ' 删除-'+ delData.ftitle " :visible.sync="delVisible"  :modal-append-to-body="false"  :width="!webW?'90%':'50%'">
            <p>请输入删除的原因</p>
            <el-input  v-model="delData.delMsg" type="textarea"/>
            <p>  <el-tag v-for="(t,i) in delMsgli" @click="delData.delMsg=t" :key="i">{{t}}</el-tag></p>

            <template #footer>
                    <span class="dialog-footer">
                        <el-button @click="delVisible = false">取 消</el-button>
                        <el-button type="primary" @click="suredel">确定删除</el-button>
                    </span>
            </template>
        </el-dialog>


    </div>


</template>
<script>
    import axios from 'axios'
    import {quillEditor, Quill} from 'vue-quill-editor'
    import {container, ImageExtend, QuillWatch} from 'quill-image-extend-module'
    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    import 'quill/dist/quill.bubble.css'
    import quillEmoji from 'quill-emoji'
    import 'quill-emoji/dist/quill-emoji.css'

    Quill.register('modules/ImageExtend', ImageExtend)
    Quill.register('modules/quillEmoji', quillEmoji)
    import '../../../api/image-paste.min.js';

    import  PubSub from 'pubsub-js'

    import {dealResult, forumImgGongge, getWindowWidth, messageSocketUrl} from '../../../api/common'
    import {

        ishit, iscollect,
        commentpage,
        saveComment, delComment,
        getUserActionForIndex, hitcomment, getVoteItemList, getVotePeopleList
        , saveMyVote, delForumByManager, saveForumTopBest, getForumDetail
    } from '../../../api';


    import Footer from "../Footer";

    export default {
        name: 'Forum',
        components: {

            quillEditor,
            Footer
        },

        data() {
            const confirmEndDate = (rule, str, callback) => {
                if (str === null || typeof str === "undefined" || str === ""|| str === "0") {
                    callback("请输入结束时间");
                }   else if (str < this.topbestData.start) {
                    callback('结束时间错误!');
                } else {
                    callback();
                }
            };
            return {
                videoplayitemWidth:0,
                nowvideo:{},

                jiugonggeWidth:500,
                jiugonggeItemWidth:0,

                IisFqz:false,
                IisBanzhu:false,

                topbestVisible: false,
                topbestData :{
                    id :'',
                    start_end:[],
                },
                topbestDataIndex:'',



                delMsgli:["广告","心术不正","言辞不雅"],
                delVisible:false,
                delData: {},


                webW:true,
                votePeopleVisible:false,
                votePeopleQuery:{
                    itemId:'',
                    pageNo:1,
                    pageSize:30,
                },
                votePeopleDataloading:true,
                votePeopleData:[],
                votePeopleDataFinish:false,
                votePeoplePageTotal:0,
                tv:{},




                editCommentVisible: false,
                editCommentData: {},

                replayVisible: false,
                replayUname: '',
                replayCont: '',
                replayData: {},



                nouse: false,//禁用



                lander: {},


                //板块信息
                typeForumLi: [],
                typeForumLiLoading: true,

                typeId: 0,
                typeInfo: {},
                ihasReplay: true,
                ihasRelease: true,

                //帖子信息
                tableData: [],


                pleditorOption: {
                    modules: {
                        'emoji-toolbar': true,
                        'emoji-shortname': true,

                        toolbar: {
                            container: ['emoji'],

                        }
                    },
                    //主题
                    theme: "snow",
                    placeholder: "请输入..."

                },

            };
        },
        methods: {
            getVideoplayitemWidth(){
                let mainDiv = document.getElementById('mainDiv');
                let mainDivWidth= mainDiv.clientWidth   || mainDiv.clientWidth;
                this.videoplayitemWidth=mainDivWidth/8-4;
            },

            playvideo2(t,i,vt,vindex){
                this.getVideoplayitemWidth();
                this.playvideo(t,i,vt,vindex);

            },

            playvideo(t,i,vt,vindex){
                this.stopvideo();

                if(vt.vurl.indexOf('/temp')>-1){
                    this.$notify({
                        title: '系统提示',
                        message: '当前播放的是临时视频可能卡顿，请稍后刷新页面重试' ,
                        duration:20000
                    });
                }

                vt.vindex=vindex;
                vt.isshow=1;
                vt.index=i;
                vt.t=t;
                this.tableData[i].nowvideo=vt;
                this.tableData[i].videosli[vindex].isplay='1';

                this.$message.info('视频加载中...');

                let v=document.getElementById('videoitem_'+t.id);
                if(v!=undefined){
                    setTimeout(()=>{
                        v.play();
                    },2000)
                }


                this.nowvideo=vt;
            },

            stopvideo(){
                if(this.nowvideo.index!=undefined&&this.nowvideo.vindex!=undefined){

                    let v=document.getElementById('videoitem_'+this.nowvideo.t.id);
                    if(v!=undefined){
                        this.tableData[this.nowvideo.index].videosli[this.nowvideo.vindex].isplay='0';
                        setTimeout(()=>{
                            v.pause();
                        },200);
                    }

                }
            },

            jiantingVideo(e){
                let id=e.target.id.split('_')[1];
                let index=e.target.dataset.index;
                let vindex=e.target.dataset.vindex;
                let currentTime=e.target.currentTime;
                let duration=e.target.duration;
                if(this.nowvideo.t==undefined){
                    return;
                }
                if(id==this.nowvideo.t.id){
                    //本视频播放
                    if(e.target.paused){
                        if(this.nowvideo.isplay!='0')this.tableData[this.nowvideo.index].videosli[this.nowvideo.vindex].isplay='0';
                    }else{
                        if(this.nowvideo.isplay!='1'){
                            this.tableData[this.nowvideo.index].videosli[this.nowvideo.vindex].isplay='1';
                        }
                    }
                }else{
                    //切换视频播放

                    if(!e.target.paused){

                        let v=document.getElementById('videoitem_'+this.nowvideo.t.id);
                        if(v!=undefined){
                            this.tableData[index].videosli[vindex].isplay='1';
                            this.tableData[this.nowvideo.index].videosli[this.nowvideo.vindex].isplay='0';
                            setTimeout(()=>{
                                v.pause();
                            },200);
                        }

                        setTimeout(()=>{
                            let nowvideo={
                                t:this.tableData[index],
                                index:index,
                                vindex:vindex,
                                vt:this.tableData[index].videosli[vindex],
                                isshow:1
                            }

                            this.nowvideo=nowvideo;
                        },1000)
                    }

                }


                if(currentTime>=duration){
                    if(this.nowvideo.t.videosli.length>1&&this.nowvideo.vindex+1<this.nowvideo.t.videosli.length){
                        let next_vindex=parseInt(vindex)+1;
                        //自动播放下一个视频

                        this.playvideo(this.nowvideo.t,this.nowvideo.index ,this.nowvideo.t.videosli[next_vindex],next_vindex);
                    }
                }

            },

            toggle(e) {
                var a = e.target,
                rel = a.getAttribute('rel');
            this.tableData[rel].hidden = !this.tableData[rel].hidden;
            },

            //删除操作
            editDelete(index,row){
                sessionStorage.managerEditForumFromIndex="1";
                this.$router.push("ForumDetail?id="+row.id+"&goPosition=top");
            },
            //删除操作
            handleDelete(index,row){
                this.delVisible=true;
                this.delData =row ;
                this.delData.index =index ;
            },

            suredel(){
                let o={  uid:this.lander.uid,
                    token:this.lander.token,
                    type:this.topbestData.type,
                    id:this.delData.id,
                    delMsg:this.delData.delMsg,
                }
                delForumByManager(o).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1  ) {
                        this.delVisible=false;
                        this.$message.success(res.data.msg);
                        this.tableData.splice(this.delData.index,1);
                    }  else {
                        this.$message.error(res.data.msg)
                    }

                })
            },

            handleCancelTopbest(index,row,type){
                this.topbestDataIndex=index;

                let o={  uid:this.lander.uid,
                    token:this.lander.token,
                    type:type,
                    start:'0',
                    end:'0',
                    id:row.id,
                }

                // 二次确认
                this.$confirm("确定取消【"+row.ftitle+"】的"+(type=='top'?'置顶？':'收录？'), "提示", {
                    type: "warning",
                }) .then(() => {

                    this.saveTopBest(o);

                });

            },
            handleTopbest(index,row,type){
                this.topbestVisible=true;
                this.topbestData.ftitle=row.ftitle;
                this.topbestData.id=row.id;
                this.topbestData.end='';
                this.topbestData.start='';
                this.topbestData.type=type;


                this.topbestDataIndex=index;

                if(type=='top'){
                    let li=[];
                    if(row.topStart!='0'){
                        this.topbestData.start=row.topStart;
                        li.push(row.topStart);
                    }
                    if(row.topEnd!='0'){
                        this.topbestData.end=row.topEnd;
                        li.push(row.topEnd);
                    }
                    this.topbestData.start_end=li;
                }
                if(type=='best'){
                    let li=[];
                    if(row.bestStart!='0'){
                        this.topbestData.start=row.bestStart;
                        li.push(row.bestStart);
                    }
                    if(row.bestEnd!='0'){
                        this.topbestData.end=row.bestEnd;
                        li.push(row.bestEnd);
                    }

                    this.topbestData.start_end=li;
                }
            },
            //保存操作
            saveTopbestHnadle(){
                // if(this.topbestData.start_end.length==0){
                //     this.$message.info("请选择时间");return;
                // }
                var startTime;
                var endTime;
                if(this.topbestData.start_end[0] == null||this.topbestData.start_end[1] == null){
                    startTime = 1,
                    endTime = 1
                }else{
                    startTime = this.topbestData.start_end[0],
                    endTime = this.topbestData.start_end[1]
                }
                let o={  uid:this.lander.uid,
                    token:this.lander.token,
                    type:this.topbestData.type,
                    start:startTime,
                    end:endTime,
                    id:this.topbestData.id,
                }
                this.saveTopBest(o);
            },
            saveTopBest(o){
                saveForumTopBest(o).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1  ) {
                        this.$message.success(res.data.msg)
                        this.topbestVisible = false;

                        this.tableData[this.topbestDataIndex].istop=res.data.obj.istop;
                        this.tableData[this.topbestDataIndex].isbest=res.data.obj.isbest;
                        this.tableData[this.topbestDataIndex].topStart=res.data.obj.topStart;
                        this.tableData[this.topbestDataIndex].topEnd=res.data.obj.topEnd;
                        this.tableData[this.topbestDataIndex].bestStart=res.data.obj.bestStart;
                        this.tableData[this.topbestDataIndex].bestEnd=res.data.obj.bestEnd;

                    }  else {
                        this.$message.error(res.data.msg)
                    }

                })
            },

            handleVotePeoplePageChange(val) {
                this.votePeopleQuery.pageNo = val;
                this.votePeopleData=[];
                this.getVotePeoplePage();

                this.votePeopleDataFinish=false;

            },

            getVotePeoplePage() {
                this.votePeopleDataloading=true;
                this.votePeopleDataFinish=false;

                this.votePeopleQuery.uid = this.lander.uid;
                this.votePeopleQuery.token = this.lander.token;
                this.votePeopleQuery.itemId =  this.tv.id;

                getVotePeopleList( this.votePeopleQuery).then((res) => {
                    this.votePeopleDataloading=false;
                    dealResult(res.data);


                    if (res.data.status == 1) {


                        let li= res.data.obj.list;
                        if(li.length==0){

                            this.votePeopleDataFinish=true;

                            return ;
                        }



                        if(this.webW) this.votePeopleData= li ;
                        else this.votePeopleData=this.votePeopleData.concat(li);
                        this.votePeoplePageTotal = res.data.obj.total//该页总共多少条记录

                        if( !this.webW  ) {
                            if( res.data.obj.hasNextPage )this.votePeopleQuery.pageNo=res.data.obj.nextPage;
                            else this.votePeopleQuery.pageNo=this.votePeopleQuery.pageNo+1;
                        }

                    }else {
                        this.votePeopleDataFinish=true;
                        this.$message.error(res.data.msg)
                    }
                })
            },
            seeVotePeople(tv){
                this.votePeopleVisible=true;
                this.tv=tv;

                this.votePeopleQuery.pageNo = 1;
                this.votePeopleData=[];
                this.votePeopleDataFinish=false;
                this.getVotePeoplePage();

            },
            saveMyVoteFunc(t,index ,o){
                this.loading = this.$loading({
                    lock: true,
                    text: "请求中...",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.5)",
                });
                saveMyVote(o).then((res) => {
                    this.loading.close();
                    dealResult(res.data);
                    if (res.data.status == 1 || res.data.status == 11) {
                        this.tableData[index].ivote='1';
                        this.getVoteItemList(index,t);
                        this.$message.success(res.data.msg)
                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
            },
            mxVoteHandle(t,index ){

                if(t.myvoteMx.length==0){
                    this.$message.info("至少选择一项");return;
                }

                let itemids="";
                for(let i=0;i<t.myvoteMx.length;i++){
                    itemids+=t.myvoteMx[i]+",";
                }
                let o = {
                    uid: this.lander.uid,
                    token: this.lander.token,
                    itemIds:itemids,
                    forumId:t.id,
                };
                this.saveMyVoteFunc(t,index ,o);

            },
            dxVoteHandle(t,index,tv,indexv){
                let o = {
                    uid: this.lander.uid,
                    token: this.lander.token,
                    itemIds:tv.id,
                    forumId:t.id,
                };
                this.saveMyVoteFunc(t,index,o);
            },
            getVotePeopleList(index,t,indexv,tv){
                let o = {
                    uid: this.lander.uid,
                    token: this.lander.token,
                    itemId:tv.id,
                };
                getVotePeopleList(o).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1 || res.data.status == 11) {
                        this.tableData[index].voteItemli[indexv].votePeopleli=res.data.obj.list ;
                        this.$forceUpdate();
                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
            },
            getVoteItemList(index,t){
                let o = {
                    uid: this.lander.uid,
                    token: this.lander.token,
                    forumId:t.id,
                };
                getVoteItemList(o).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1 || res.data.status == 11) {
                        let li=res.data.obj.voteItemList;
                        for(let i=0;i<li.length;i++){
                            li[i].votePeopleli=[];
                        }
                        this.tableData[index].voteItemli=li;
                        this.tableData[index].ivote=res.data.obj.ivote;


                        for(let i=0;i<li.length;i++){
                            if(li[i].peopleNum>0) this.getVotePeopleList(index,t,i,li[i]);
                        }
                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
            },
            goUHome(uid){
                this.$router.push('Home?type=myforum&authorId='+uid);
            },
            goForumItem(t, index, type) {
                this.$router.push('ForumDetail?id=' + t.id + "&goPosition=" + type);
            },

            hitComment(t, index, tc, indexc, type, thf, indexf) {
                let o = {
                    uid: this.lander.uid,
                    token: this.lander.token,
                    commentId: tc.id,
                };
                if (type == 2) o.commentId = thf.id;
                hitcomment(o).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1 || res.data.status == 11) {
                        if (res.data.status == 1) this.$message.success(res.data.msg)
                        if (res.data.status == 11) this.$message.info(res.data.msg)

                        if (type == 1) this.tableData[index].commentli[indexc].hitNum = res.data.obj;
                        if (type == 2) this.tableData[index].commentli[indexc].hfli[indexf].hitNum = res.data.obj;


                        let mess={name:this.lander.uid+"",receiver:t.authorUid+"",msg:this.lander.uname+" "+(res.data.status == 11?'取消了':'')+"点赞你的评论"}
                        this.sendMessage(JSON.stringify(mess))

                    } else {
                        this.$message.error(res.data.msg)
                    }
                })

            },
            sendMessage(msg){
                let that = this;
                console.log(that.$messageSocket.ws);
                if (that.$messageSocket.ws && that.$messageSocket.ws.readyState == 1) {
                    console.log("发送信息", msg);
                    that.$messageSocket.ws.send(msg);
                }else{
                    that.ws = new WebSocket(messageSocketUrl+this.lander.uid);
                    that.$messageSocket.setWs(that.ws);
                    setTimeout(()=>{
                        console.log("setTimeout发送信息", msg);
                        that.$messageSocket.ws.send(msg);
                    },2000)
                }
            },
            editComment(t, index, tc, indexc, type, thf, indexf) {

                this.editCommentVisible = true;

                this.editCommentData.index = index;
                this.editCommentData.type = type;

                this.editCommentData.indexc = indexc;
                
                if(type==2){
                    this.editCommentData.id = thf.id;
                    this.editCommentData.cont = thf.cont;
                    this.editCommentData.indexf = indexf;
                }else{
                    this.editCommentData.id = tc.id;
                    this.editCommentData.cont = tc.cont;

                }

            },
            editsaveComment() {
                //去除<p>标签，过滤样式
                this.editCommentData.cont = this.editCommentData.cont.replace(/<([a-zA-Z1-6]+)(\s*[^>]*)?>/g, "<$1>").replace(/<p><br><\/p>/g, '<br />').replace(/<p>([^<]*?)<\/p>/gi, '$1<br/>');
                //
                let c = this.editCommentData.cont;
                if (c == undefined || c.trim().length == 0) {
                    this.$message.error('请输入评论内容');
                    return;
                }
                if (c.trim().length > 2000000) {
                    this.$message.error('评论内容200字以内');
                    return;
                }

                this.loading = this.$loading({
                    lock: true,
                    text: "保存中...",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.5)",
                });

                let o = {
                    uid: this.lander.uid,
                    token: this.lander.token,
                    id: this.editCommentData.id,
                    cont: c,
                }
                saveComment(o).then((res) => {
                    this.loading.close();
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.editCommentVisible = false;
                        if (this.editCommentData.type == 1) this.tableData[this.editCommentData.index].commentli[this.editCommentData.indexc].cont = c;
                        if (this.editCommentData.type == 2) this.tableData[this.editCommentData.index].commentli[this.editCommentData.indexc].hfli[this.editCommentData.indexf].cont = c;

                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
            },
            replayHandle(t, index, tc, ic, type, thf) {
                if (type == 1) this.replayUname = tc.uname;
                if (type == 2) this.replayUname = thf.uname;
                if (type == 3) this.replayUname = thf.hfuname;
                this.replayVisible = true;
                this.replayData = tc;
                this.replayData.index = index;
                this.replayData.indexc = ic;
                this.replayData.type = type;
                this.replayData.thf = thf;

                this.replayCont = '';
            },

            saveReplay() {
                let c = this.replayCont;
                if (c == undefined || c.trim().length == 0) {
                    this.$message.error('请输入评论内容');
                    return;
                }
                if (c.trim().length > 200000) {
                    this.$message.error('评论内容200字以内');
                    return;
                }
                let o = {
                    uid: this.lander.uid,
                    token: this.lander.token,
                    forumId: this.replayData.forumId,
                    cont: c,
                    hfId: this.replayData.id,
                    hfUid: this.replayData.commentUid,
                }

                if (this.replayData.type == 2) {
                    o.hfUid = this.replayData.thf.commentUid;
                }
                if (this.replayData.type == 3) {
                    o.hfUid = this.replayData.thf.hfUid;
                }

                this.loading = this.$loading({
                    lock: true,
                    text: "保存中...",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.5)",
                });

                saveComment(o).then((res) => {
                    this.loading.close();
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.replayVisible = false;
                        this.tableData[this.replayData.index].commentNum = res.data.obj.commentNum;
                        this.tableData[this.replayData.index].commentli[this.replayData.indexc].hfli.unshift(res.data.obj.commentobj);
                        this.tableData[this.replayData.index].commentli[this.replayData.indexc].replayNum = res.data.obj.commentobj.replayNum;




                        let mess={name:this.lander.uid+"",receiver:o.hfUid+"",msg:this.lander.uname+" "+ "回复了你"}
                        this.sendMessage(JSON.stringify(mess))

                        let atli=res.data.obj.atli;
                        if(atli!=null&&atli.length>0){
                            for(let i=0;i<atli.length;i++){
                                let mess2={name:this.lander.uid+"",receiver:atli[i]+"",msg:this.lander.uname+" "+ "在评论里 @ 了你"}
                                this.sendMessage(JSON.stringify(mess2))
                            }
                        }




                    } else {
                        this.$message.error(res.data.msg)
                    }
                })

            },
            subComment(t, index) {
                let c = t.commentCont;
                if (c == undefined || c.trim().length == 0) {
                    this.$message.error('请输入评论内容');
                    return;
                }
                if (c.trim().length > 200000) {
                    this.$message.error('评论内容200字以内');
                    return;
                }
                this.loading = this.$loading({
                    lock: true,
                    text: "保存中...",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.5)",
                });
                let o = {
                    uid: this.lander.uid,
                    token: this.lander.token,
                    forumId: t.id,
                    cont: c,
                }
                saveComment(o).then((res) => {
                    this.loading.close();
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.tableData[index].commentCont = '';
                        this.tableData[index].commentNum = res.data.obj.commentNum;

                        let obj = res.data.obj.commentobj;
                        obj.hfliLoading = false;
                        obj.hfli = [];
                        this.tableData[index].commentli.unshift(obj);


                        let mess={name:this.lander.uid+"",receiver:t.authorUid+"",msg:this.lander.uname+" "+ "评论你的帖子"}
                        this.sendMessage(JSON.stringify(mess))

                        let atli=res.data.obj.atli;
                        if(atli!=null&&atli.length>0){
                            for(let i=0;i<atli.length;i++){
                                let mess2={name:this.lander.uid+"",receiver:atli[i]+"",msg:this.lander.uname+" "+ "在评论里@了你"}
                                this.sendMessage(JSON.stringify(mess2))
                            }
                        }




                    } else {
                        this.$message.error(res.data.msg)
                    }
                })


            },

            deleteCommentReplay(t, index, tc, indexc, thf, indexhf) {

                this.loading = this.$loading({
                    lock: true,
                    text: "删除中...",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.5)",
                });

                let o = {
                    uid: this.lander.uid,
                    token: this.lander.token,
                    id: thf.id,
                }
                delComment(o).then((res) => {
                    this.loading.close();
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.$message.success(res.data.msg);

                        this.tableData[index].commentli[indexc].hfli.splice(indexhf, 1);


                        this.tableData[index].commentNum = res.data.obj;

                    } else {
                        this.$message.error(res.data.msg)
                    }
                })


            },
            deleteComment(t, index, tc, indexc) {

                this.loading = this.$loading({
                    lock: true,
                    text: "删除中...",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.5)",
                });

                let o = {
                    uid: this.lander.uid,
                    token: this.lander.token,
                    id: tc.id,
                }
                delComment(o).then((res) => {
                    this.loading.close();
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.$message.success(res.data.msg);
                        this.tableData[index].commentli.splice(indexc, 1);
                        this.tableData[index].commentNum = res.data.obj;

                        let mess={name:this.lander.uid+"",receiver:t.authorUid+"",msg:this.lander.uname+" 删除了评论"}
                        this.sendMessage(JSON.stringify(mess))

                    } else {
                        this.$message.error(res.data.msg)
                    }
                })


            },
            closeComments(t, index) {
                this.tableData[index].showComments = false;
            },
            seeCommentHandel(t, index) {
                this.tableData[index].showComments = !this.tableData[index].showComments;
                if (this.tableData[index].commentli.length == 0) this.getOneForumLastComments(t, index);
            },
            getOneForumLastComments(t, index) {
                this.tableData[index].commentliLoading = true;
                let o = {
                    uid: this.lander.uid,
                    token: this.lander.token,
                    forumId: t.id,
                    hfId: 0,
                    pageSize:3,
                }
                commentpage(o).then((res) => {
                    this.tableData[index].commentliLoading = false;
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        let cli = res.data.obj.list;

                        for (let i = 0; i < cli.length; i++) {
                            cli[i].hfli = [];
                            cli[i].hfliLoading = true;
                            if (cli[i].replayNum > 0) this.getOneForumLastCommentsReplay(t, index, cli[i], i);
                            else {
                                cli[i].hfliLoading = false;
                            }
                        }
                        this.tableData[index].commentli = cli;
                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
            },
            getOneForumLastCommentsReplay(t, index, tc, indexc) {
                let o = {
                    uid: this.lander.uid,
                    token: this.lander.token,
                    hfId: tc.id,
                }
                commentpage(o).then((res) => {
                    this.tableData[index].commentli[indexc].hfliLoading = false;
                    if (res.data.status == 1) {
                        let rli = res.data.obj.list;
                        this.tableData[index].commentli[indexc].hfli = rli;
                    }
                })
            },

            collectHandle(t, index) {
                let o = {
                    uid: this.lander.uid,
                    token: this.lander.token,
                    forumId: t.id
                }
                this.loading = this.$loading({
                    lock: true,
                    text: "请求中...",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.5)",
                });
                iscollect(o).then((res) => {
                    dealResult(res.data);
                    this.loading.close();
                    if (res.data.status == 1) {
                        this.tableData[index].iscollect = "1";
                        this.tableData[index].collectNum = res.data.obj;
                        this.$message.success(res.data.msg)
                    } else if (res.data.status == 11) {
                        this.tableData[index].iscollect = "0";
                        this.tableData[index].collectNum = res.data.obj;
                        this.$message.info(res.data.msg)
                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
            },
            hitHandle(t, index) {
                let o = {
                    uid: this.lander.uid,
                    token: this.lander.token,
                    forumId: t.id
                }
                this.loading = this.$loading({
                    lock: true,
                    text: "请求中...",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.5)",
                });
                ishit(o).then((res) => {
                    dealResult(res.data);
                    this.loading.close();
                    if (res.data.status == 1) {
                        this.tableData[index].ishit = "1";
                        this.tableData[index].hitNum = res.data.obj;
                        this.$message.success(res.data.msg)
                    } else if (res.data.status == 11) {
                        this.tableData[index].ishit = "0";
                        this.tableData[index].hitNum = res.data.obj;
                        this.$message.info(res.data.msg)
                    } else {
                        this.$message.error(res.data.msg)
                    }
                    if (res.data.status == 1||res.data.status == 11) {

                        let mess={name:this.lander.uid+"",receiver:t.authorUid+"",msg:this.lander.uname+" "+(res.data.status == 11?'取消了':'')+"点赞你的帖子"}
                        this.sendMessage(JSON.stringify(mess))

                    }


                })
            },








            //展示用户是否点赞和评论
            getUserActionForIndexFunc(li) {
                let forumIds = '';
                for (let i = 0; i < li.length; i++) {
                    forumIds += li[i].id + ",";
                }

                let o={
                    uid:this.lander.uid,
                    token:this.lander.token,
                    forumIds:forumIds
                }


                getUserActionForIndex(o).then((res) => {

                    if (res.data.status == 1) {
                        let li2 = res.data.obj;
                        for (let i = 0; i < li2.length; i++) {
                            let index = (this.tableData || []).findIndex((item) => item.id === li2[i].id);
                            this.tableData[index].iscollect = li2[i].iscollect;
                            this.tableData[index].ishit = li2[i].ishit;
                        }

                    }
                })
            },


            getForumDetailFunc(id,index) {
                getForumDetail({uid: this.lander.uid, token: this.lander.token,id: id}).then((res) => {
                    if (res.data.status == 1) {
                        let f=res.data.obj.forumobj;

                        this.tableData[index].ftitle=f.ftitle;
                        this.tableData[index].fcontext=f.fcontext;
                        this.tableData[index].editTs=f.editTs;

                        this.tableData[index].isVote=f.isVote;
                        this.tableData[index].vtype=f.vtype;
                        this.tableData[index].vstartTs=f.vstartTs;
                        this.tableData[index].vendTs=f.vendTs;
                        this.tableData[index].vshowNum=f.vshowNum;
                        this.tableData[index].vshowPeople=f.vshowPeople;
                        this.tableData[index].voteState=f.voteState;
                        this.tableData[index].voteNum=f.voteNum;

                        this.getVoteItemList(index,this.tableData[index]);
                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
            },



        }, mounted() {
            let windowWidth=getWindowWidth();
            this.webW=(windowWidth>=1000?true:false);

            if(windowWidth>this.jiugonggeWidth){
                this.jiugonggeItemWidth=this.jiugonggeWidth/forumImgGongge-4 ;
            }else{
                this.jiugonggeItemWidth=(windowWidth-30)/forumImgGongge-4 ;
            }



            this.lander = JSON.parse(this.$store.state.logininfo);
            if(this.lander.state!='1'){
                this.nouse=true;
            }


            PubSub.subscribe('forumDataListForItem_home',(msg,li)=>{
                //这里不写，他请求的还是老的token会过期，原因不明
                this.lander = JSON.parse(this.$store.state.logininfo);

                if(li!=null){
                    let endindex=this.tableData.length;
                    this.tableData= this.tableData.concat(li);

                    for(let i=endindex;i<this.tableData.length;i++){
                        if(this.tableData[i].isVote=='1')this.getVoteItemList(i,this.tableData[i]);
                    }

                    this.getUserActionForIndexFunc(li);

                }else{
                    this.tableData=[];
                }

            });
            PubSub.subscribe('delFormListIndex',(msg,id)=>{
                let  index = ( this.tableData || []).findIndex((item) => item.id === id);
                if(index>=0)this.tableData.splice(index,1);

            });
            PubSub.subscribe('editFormListIndex',(msg,id)=>{
                let  index = ( this.tableData || []).findIndex((item) => item.id === id);
                if(index>=0) {
                    this.getForumDetailFunc(id,index);
                }

            });
            PubSub.subscribe('typeAndQx',(msg,obj)=>{
                this.typeInfo=obj;
                this.ihasReplay=obj.ihasReplay;
                this.ihasReplay=obj.ihasReplay;
                this.typeId=obj.id;

            });

        },
        activated() {

        },
        deactivated() {
            this.stopvideo();
        }

    };
</script>
<style scoped>

/deep/ .ql-container {
       min-height:34.71px;
   }

   .Tool_check {
    position: relative;
    top: -10px;
    right: 13px;
    float: right;
    }

   .fpledit {
     display: flex;
     width: 100%;
     flex-direction:column-reverse
   }
   .fpledit /deep/ .ql-container.ql-snow {
     border:0;
   }
   .fpledit /deep/ .ql-toolbar.ql-snow {
     border:0;
     background: none;
   }
   .fpledit /deep/ .ql-toolbar.ql-snow .ql-fill{
     color:red;
   }
   .fpledit /deep/ .ql-toolbar.ql-snow .ql-formats .ql-emoji {
     height: 3.5rem;
   }
   .fpledit /deep/ .ql-container .ql-editor {
       padding:6px 11px;
       font-size: 16px;
       word-break:break-all;
       white-space:normal; 
   }



   .fpledit /deep/ .ql-container {
       background: #ffffff;
       
       padding: 0 0;
       width: 100%;
   }
   .fpledit /deep/ .ql-toolbar {
       width:50px;
       height:40px;
       margin-left: 10px;
       background: #ffffff;
       
   }

    .el-checkbox-group {
        font-size: 13px;
    }





</style>
